import styled from 'styled-components'

import { ClinTheme } from '../../../../ClinTheme'
import { ClinAnnounceBar } from '../../../../components/ClinAnnounceBar'
import { ClinButton } from '../../../../components/ClinButton'

/** Tab panel — Figma Frame 1338 (8601:6328) */
export const StyledConsentBaselineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: ${ClinTheme.colors.white};
  padding: 48px 64px 64px;
`

export const StyledIntroText = styled.p`
  margin: 0;
  font-size: ${ClinTheme.fontSizes[1]}px;
  font-weight: ${ClinTheme.fontWeights.normal};
  line-height: 24px;
  color: ${ClinTheme.colors.black};
`

/** Step card — Figma Frame 1347 (8601:6331) */
export const StyledStep = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  background-color: ${ClinTheme.colors.greyIndigo};
  border-radius: 8px;
  padding: 16px;
`

export const StyledStepLabel = styled.div`
  flex: 0 0 89px;
  font-size: ${ClinTheme.fontSizes[1]}px;
  font-weight: ${ClinTheme.fontWeights.bold};
  line-height: 24px;
  color: ${ClinTheme.colors.black};
`

export const StyledStepBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  min-width: 0;
`

/** Inline step alert, Figma "Step 2 / API call returns null/incomplete" */
export const StyledStepAlert = styled(ClinAnnounceBar)`
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding-right: ${ClinTheme.space[4]}px;
  border: none;
  background-color: ${ClinTheme.colors.statusRed};

  .pta-step-alert-message {
    margin-right: ${ClinTheme.space[2]}px;
    color: ${ClinTheme.colors.black};
    line-height: 20px;
  }

  .pta-step-alert-message > div {
    letter-spacing: normal;
  }

  .pta-step-alert-message > :empty {
    display: none;
  }
`

export const StyledStepInstruction = styled.p`
  margin: 0;
  width: 100%;
  font-size: ${ClinTheme.fontSizes[1]}px;
  font-weight: ${ClinTheme.fontWeights.normal};
  line-height: 24px;
  color: ${ClinTheme.colors.black};
`

/** Figma buttons:Secondary — Style=Filled (node 8572:2823) */
export const StyledStepButton = styled(ClinButton)`
  box-sizing: border-box;
  width: fit-content;
  min-width: 181px;
  height: ${ClinTheme.space[5]}px;
  min-height: ${ClinTheme.space[5]}px;
  padding: ${ClinTheme.space[2]}px ${ClinTheme.space[6]}px;
  border-radius: 100px;
  text-transform: none;
  font-weight: ${ClinTheme.fontWeights.medium};
  line-height: ${ClinTheme.space[3]}px;
  letter-spacing: 0;
  white-space: nowrap;
`

/** CLOS-13955 — post-capture "View consent" as a less-prominent link */
export const StyledStepLink = styled(ClinButton)`
  box-sizing: border-box;
  width: fit-content;
  min-width: 0;
  height: auto;
  min-height: 0;
  padding: 0;
  border-radius: 0;
  text-transform: none;
  font-weight: ${ClinTheme.fontWeights.medium};
  line-height: ${ClinTheme.space[3]}px;
  letter-spacing: 0;
  white-space: nowrap;
`

/** Success chip — Figma Frame 1034 */
export const StyledStatusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 24px;
  padding: 0 20px 0 8px;
  background-color: ${ClinTheme.colors.lightenGreen};
  border-radius: 8px;
`

export const StyledStatusIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${ClinTheme.colors.greenValid};
  flex-shrink: 0;
`

export const StyledStatusText = styled.span`
  font-size: ${ClinTheme.fontSizes[1]}px;
  font-weight: ${ClinTheme.fontWeights.normal};
  line-height: 24px;
  color: ${ClinTheme.colors.black};
`

export const StyledStepsStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

/** Nested inside Step 2 (CLOS-13913) — no extra top gap beyond step body spacing */
export const StyledConfirmationSection = styled.div`
  width: 100%;

  .clin-checkbox {
    align-items: flex-start;
  }
`
